import {
  AccordionModule,
  BreadcrumbsModule,
  ChipsModule,
  DropdownModule,
  ExpandCollapseModule,
  FlexboxModule,
  FootnoteModule,
  GridModule,
  HeaderRendererComponent,
  IconModule,
  InfoItemModule,
  LinkItemModule,
  NotificationsModule,
  PaddingModule,
  PaginationModule,
  PanelModule,
  ProximalModule,
  SearchModule,
  SpacingModule,
  SwitchModule,
  TabsModule,
  TitleModule,
  ToggleModule,
  TooltipModule,
  LinkModule,
  RatingModule,
  SideBarModule,
} from '@frk/eds-components';
import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';

import { AgGridModule } from '@ag-grid-community/angular';
import { BrSdkModule } from '@bloomreach/ng-sdk';
import { CalcTypeGroupHeaderComponent } from './ag-grid-helpers/group-headers/calc-type-group-header/calc-type-group-header.component';
import { CommonModule } from '@angular/common';
import { DateGroupHeaderComponent } from './ag-grid-helpers/group-headers/date-group-header/date-group-header.component';
import { ExpenseRatioCellRendererComponent } from './ag-grid-helpers/cell-renderers/expense-ratio-cell-renderer/expense-ratio-cell-renderer.component';
import { FundDocumentCellRendererComponent } from './ag-grid-helpers/cell-renderers/fund-document-cell-renderer/fund-document-cell-renderer.component';
import { FundFiltersComponent } from './fund-filters/fund-filters.component';
import { FundListingEntryComponent } from './fund-listing-entry/fund-listing-entry.component';
import { FundNameCellRendererComponent } from './ag-grid-helpers/cell-renderers/fund-name-cell-renderer/fund-name-cell-renderer.component';
import { NavCellRendererComponent } from './ag-grid-helpers/cell-renderers/nav-cell-renderer/nav-cell-renderer.component';
import { NgModule } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { PerformanceGroupHeaderComponent } from './ag-grid-helpers/group-headers/performance-group-header/performance-group-header.component';
import { PpssCardComponent } from './ppss-card/ppss-card.component';
import { PpssCardContainerComponent } from './ppss-card-container/ppss-card-container.component';
import { PpssComponent } from './ppss/ppss.component';
import { PpssFundidentifiersComponent } from './ppss/ppss-fundidentifiers/ppss-fundIdentifiers.component';
import { PpssPerformanceComponent } from './ppss/ppss-performance/ppss-performance.component';
import { PpssRatingsComponent } from './ppss/ppss-ratings/ppss-ratings.component';
import { PpssYieldsComponent } from './ppss/ppss-yields/ppss-yields.component';
import { RatingsCellRendererComponent } from './ag-grid-helpers/cell-renderers/ratings-cell-renderer/ratings-cell-renderer.component';
import { RatingsGroupHeaderComponent } from './ag-grid-helpers/group-headers/ratings-group-header/ratings-group-header.component';
import { RouterModule } from '@angular/router';
import { SignInModule } from '@shared/sign-in/sign-in.module';
import { TranslateModule } from '@shared/translate/translate.module';
import { VisualHintModule } from '@shared/visual-hint/visual-hint.module';
import { ModuleRegistry } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { FavFundCellRendererComponent } from '@products/fund-listing/ag-grid-helpers/cell-renderers/fav-fund-cell-renderer/fav-fund-cell-renderer.component';
import { FundNameNjBestCellRendererComponent } from './ag-grid-helpers/cell-renderers/fund-name-njbest-cell-renderer/fund-name-njbest-cell-renderer.component';
import { PpssPriceComponent } from './ppss/ppss-price/ppss-price.component';
import { PriceGroupHeaderComponent } from './ag-grid-helpers/group-headers/price-group-header/price-group-header.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '@shared/shared.module';

/**
 * Module for GW PPSS component
 */
@NgModule({
  imports: [
    CommonModule,
    BrSdkModule,
    ExpandCollapseModule,
    NotificationsModule,
    TabsModule,
    IconModule,
    InfoItemModule,
    TranslateModule,
    DropdownModule,
    AccordionModule,
    TitleModule,
    PanelModule,
    LinkModule,
    ChipsModule,
    LinkItemModule,
    PaginationModule,
    SearchModule,
    ProximalModule,
    FootnoteModule,
    SpacingModule,
    PaddingModule,
    SignInModule,
    SwitchModule,
    ToggleModule,
    TooltipModule,
    BreadcrumbsModule,
    VisualHintModule,
    RatingModule,
    NgxSpinnerModule,
    RouterModule,
    NgxSkeletonLoaderModule,
    AgGridModule.withComponents([
      NavCellRendererComponent,
      CalcTypeGroupHeaderComponent,
      RatingsCellRendererComponent,
      RatingsGroupHeaderComponent,
      PerformanceGroupHeaderComponent,
      PriceGroupHeaderComponent,
      DateGroupHeaderComponent,
      HeaderRendererComponent,
      FavFundCellRendererComponent,
    ]),
    GridModule,
    FlexboxModule,
    SharedModule,
    SideBarModule,
  ],
  declarations: [
    FundListingEntryComponent,
    DateGroupHeaderComponent,
    PpssComponent,
    PpssPerformanceComponent,
    PpssPriceComponent,
    PpssFundidentifiersComponent,
    PpssYieldsComponent,
    PpssRatingsComponent,
    NavCellRendererComponent,
    RatingsCellRendererComponent,
    RatingsGroupHeaderComponent,
    CalcTypeGroupHeaderComponent,
    PpssCardComponent,
    PpssCardContainerComponent,
    FundFiltersComponent,
    PerformanceGroupHeaderComponent,
    PriceGroupHeaderComponent,
    FundDocumentCellRendererComponent,
    FundNameCellRendererComponent,
    FundNameNjBestCellRendererComponent,
    ExpenseRatioCellRendererComponent,
    FavFundCellRendererComponent,
  ],
  exports: [PpssCardComponent],
})
export class FundListingModule implements DynamicModule {
  constructor() {
    ModuleRegistry.registerModules([ClientSideRowModelModule]);
  }

  getComponentMapping(): ComponentMapping {
    return {
      'Fund Listing': FundListingEntryComponent,
    };
  }
}
